import React from 'react';
import classNames from 'classnames';
import path from 'path';
import { PMS_URL } from '../../config';
import { AppLink } from '../modules/routing/containers';

class ManagementMenu extends React.Component {
  constructor(props) {
    super(props);
    this.isActive = this.isActive.bind(this);
    this.isDropdownOpen = this.isDropdownOpen.bind(this);
    this.state = {
      dropdowns: {
        booking: false,
        email: false,
      }
    };
  }
  componentDidMount() {
    this.openDropdownFor(this.props.location.pathname);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.openDropdownFor(nextProps.location.pathname);
    }
  }

  render() {
    const root = "/management";
    return (
      <ul className="sidebar-menu">
        <li className={ classNames({ active: this.isActive('/daily-rental/customers') }) }>
          <AppLink to="/daily-rental/customers" customRoot={ root }><i className="fas fa-users fa-fw"></i> <span>Customers</span></AppLink>
        </li>

        <li className={ classNames('treeview', { active: this.isDropdownOpen('email') }) }>
          <a href="#" onClick={ this.handleClickDropdown.bind(this, 'email') }>
            <i className="fas fa-envelope fa-fw"></i> <span>Messages</span><i className="fas fa-angle-left pull-right"></i>
          </a>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/email/messages') }) }>
              <AppLink to="/email/messages" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Emails</span></AppLink>
            </li>
            <li className={ classNames({ active: this.isActive('/email/templates') }) }>
              <AppLink to="/email/templates" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Email templates</span></AppLink>
            </li>
            <li className={ classNames({ active: this.isActive('/email/automatic-sendings') }) }>
              <AppLink to="/email/automatic-sendings" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Automatic sendings</span></AppLink>
            </li>
          </ul>
        </li>

        <li className={ classNames('treeview', { active: this.isDropdownOpen('booking') }) }>
          <a href="#" onClick={ this.handleClickDropdown.bind(this, 'booking') }>
            <i className="far fa-calendar-alt fa-fw"></i> <span>Daily rental</span><i className="fas fa-angle-left pull-right"></i>
          </a>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/daily-rental/inquiries') }) }>
              <AppLink to="/daily-rental/inquiries" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Inquiries</span></AppLink>
            </li>
            <li className={ classNames({ active: this.isActive('/daily-rental/reservations') }) }>
              <AppLink to="/daily-rental/reservations" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Reservations</span></AppLink>
            </li>
            <li className={ classNames({ active: this.isActive('/daily-rental/availabilities/calendar') }) }>
              <AppLink to="/daily-rental/availabilities/calendar" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Availabilities calendar</span></AppLink>
            </li>
          </ul>
        </li>

      </ul>
    );
  }

  isActive(url) {
    const [pathname, searchParams] = url.split('?');
    return this.props.location.pathname.match(`^${this.resolveUrl(pathname)}`)
      && this.props.location.search.match(searchParams);
  }
  isDropdownOpen(name) {
    return this.state.dropdowns[name];
  }
  openDropdownFor(url) {
    let name;
    if (url.match(`^${this.resolveUrl('/daily-rental')}`)) name = 'booking';
    if (url.match(`^${this.resolveUrl('/email')}`)) name = 'email';
    const dropdowns = Object.keys(this.state.dropdowns).reduce((object, _name) => ({ ...object, [_name]: false }), {});
    if (name) dropdowns[name] = true;
    this.setState({ dropdowns });
  }
  handleClickDropdown(name, evt = null) {
    if (evt) { evt.preventDefault(); }
    const dropdowns = { ...this.state.dropdowns };
    Object.keys(dropdowns)
      .filter(n => n !== name)
      .map(n => dropdowns[n] = false);
    dropdowns[name] = !dropdowns[name];
    this.setState({ dropdowns });
  }

  resolveUrl(url) {
    const currentUrl = path.join('/management', url);
    return PMS_URL === '/' ? currentUrl : `${PMS_URL}${currentUrl}`;
  }
}

ManagementMenu.propTypes = {
  location: React.PropTypes.object,
};

export default ManagementMenu;



// WEBPACK FOOTER //
// ./src/frontend/layout/ManagementMenu.jsx